import * as Actions from '../actions/actions'
import * as ActionTypes from '../actions/types'
import { API, PortalToken } from "../helpers/constants";
import { requestCreator } from '../helpers/redux/requestCreator'

const checkAPIConnectivity = requestCreator({
	nonApiUrl: true,
	url: API + '/portcheck.txt?t=' + (new Date()).getTime(),
	method: 'GET',
	onSuccess: Actions.checkAPIConnectivitySucceeded,
	onFailure: Actions.checkAPIConnectivityFailed
})

// User --------------------------------------------------------
const userLogout = requestCreator({
	url: '/logout',
	method: 'GET', // Change to POST if API uses POST
	onSuccess: Actions.userLogoutSucceeded,
	onFailure: Actions.userLogoutFailed,
	headers: {
		'Content-Type': 'multipart/form-data',
		'TokenGuid': PortalToken
	}
})

const userLogin = requestCreator({
	url: '/login',
	method: 'POST',
	onSuccess: Actions.userLoginSucceeded,
	onFailure: Actions.userLoginFailed,
	headers: {
		'Content-Type': 'multipart/form-data',
		'TokenGuid': PortalToken
	}
})

const requestResetPassword = requestCreator({
	url: '/request/new-password',
	method: 'GET',
	onSuccess: Actions.requestResetPasswordSucceeded,
	onFailure: Actions.requestResetPasswordFailed,
	headers: {
		'Content-Type': 'multipart/form-data',
		'TokenGuid': PortalToken
	}
})

const resetPassword = requestCreator({
	url: '/store/new/password',
	method: 'POST',
	onSuccess: Actions.resetPasswordSucceeded,
	onFailure: Actions.resetPasswordFailed,
	headers: {
		'Content-Type': 'multipart/form-data',
		'TokenGuid': PortalToken
	}
})

const getUserDetails = requestCreator({
	url: '/portal/user/details',
	method: 'GET',
	onSuccess: Actions.getUserDetailsSucceeded,
	onFailure: Actions.getUserDetailsFailed,
})

// Grid State -------------------------------------------------
const getGridState = requestCreator({
	url: '/uigrid/state/load',
	method: 'POST',
	onSuccess: Actions.getGridStateSucceeded,
	onFailure: Actions.getGridStateFailed,
})

const saveGridState = requestCreator({
	url: '/uigrid/state/save',
	method: 'POST',
	onSuccess: Actions.saveGridStateSucceeded,
	onFailure: Actions.saveGridStateFailed,
})

const deleteGridState = requestCreator({
	url: '/uigrid/state/save',
	method: 'POST',
	onSuccess: Actions.deleteGridStateSucceeded,
	onFailure: Actions.deleteGridStateFailed,
})

const setActiveGridState = requestCreator({
	url: '/uigrid/state/save',
	method: 'POST',
	onSuccess: Actions.setActiveGridStateSucceeded,
	onFailure: Actions.setActiveGridStateFailed,
})

// Cart --------------------------------------------------------

const getCart = requestCreator({
	url: "/brew/cart/index",
	method: "POST",
	onSuccess: Actions.getCartSucceeded,
	onFailure: Actions.getCartFailed,
	headers: {
		Accept: "application/json",
		TokenGuid: PortalToken,
	},
});

const editCart = requestCreator({
	url: "/brew/cart/edit",
	method: "POST",
	onSuccess: Actions.editCartSucceeded,
	onFailure: Actions.editCartFailed,
	headers: {
		Accept: "application/json",
		TokenGuid: PortalToken,
	},
});


const requestHandler = {
	[ActionTypes.CHECK_API_CONNECTIVITY]: checkAPIConnectivity,
	// User -----------------------------------------------
	[ActionTypes.USER_LOGOUT]: userLogout,
	[ActionTypes.USER_LOGIN]: userLogin,
	[ActionTypes.REQUEST_RESET_PASSWORD]: requestResetPassword,
	[ActionTypes.RESET_PASSWORD]: resetPassword,
	[ActionTypes.GET_USER_DETAILS]: getUserDetails,
	// Grid State -------------------------------------------------
	[ActionTypes.GET_GRID_STATE]: getGridState,
	[ActionTypes.SAVE_GRID_STATE]: saveGridState,
	[ActionTypes.DELETE_GRID_STATE]: deleteGridState,
	[ActionTypes.SET_ACTIVE_GRID_STATE]: setActiveGridState,

	// Cart -----------------------------------------------
	[ActionTypes.CART_GET]: getCart,
	[ActionTypes.CART_EDIT]: editCart,
}

export default requestHandler
